import * as Sentry from '@sentry/nuxt';

export default defineNuxtPlugin((nuxtApp) => {
  // Catch unhandled Vue errors (lifecycle hooks, render, watchers)
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    Sentry.captureException(error, {
      tags: {
        handler: 'vue-global',
        info: info || 'unknown'
      },
      extra: {
        componentName: instance?.$options?.name || instance?.$options?.__name
      }
    });
  };

  // Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason || 'Unhandled promise rejection', {
      tags: { handler: 'unhandled-promise' }
    });
  });
});
